<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__title">产品管理</div>
    </div>
    <div class="page-panel__body">
      <el-form class="page-panel-search-form" :inline="true">
        <el-form-item class="page-panel-search-form-right-button">
          <el-button type="primary"
            @click="dialogVisable=true,dialogTitle='新增产品信息',addProductParam={productRecommend:1},imageUrl=''">新增
          </el-button>
        </el-form-item>
      </el-form>
      <el-table :data="porductList" :fit='true'>
        <el-table-column label="序号" type="index" width="50" align="center">
        </el-table-column>
        <el-table-column label="编号" prop='productComid' align="center" width="100">
        </el-table-column>
        <el-table-column label="产品名称" align="center" prop="productName" width="80">
        </el-table-column>
        <el-table-column label="产品类别" align="center" prop="typeName" width="80">
        </el-table-column>
        <el-table-column label="产品图片" align="center" width="110">
          <template slot-scope="scope">
            <img :src="scope.row.productImg?scope.row.productImg:'/static/img/common/zwtp.png'" class="table_image"
              onerror="this.src='/static/img/common/zwtp.png'">
          </template>
        </el-table-column>
        <el-table-column label="所属单位" align="center" prop="companyName">
        </el-table-column>
        <el-table-column label="推荐" align="center" width="150">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.productRecommend" :active-value=1 :inactive-value=0 active-text='是'
              inactive-text='否' @change="switchChange(scope.row,'productRecommend')">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="信息录入人" align="center" prop="authorName" width="90">
        </el-table-column>
        <el-table-column label="录入日期" align="center" prop="productAddTime" width="100">
        </el-table-column>
        <el-table-column label="审核状态" align="center" width="150">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.productState" :active-value=1 :inactive-value=0 active-text='是'
              inactive-text='否' @change="switchChange(scope.row,'productState')">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="170">
          <template slot-scope="scope">
            <el-button type="text" @click="viewProductDetail(scope.row.productId)">查看</el-button>
            <el-button type="text" @click="getProductDetail(scope.row.productId)">编辑</el-button>
            <el-button type="text" @click="deleteProduct(scope.row.productId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-panel__footer">
        <el-pagination :current-page.sync='searchModel.pageNo' :page-size='searchModel.pageSize'
          layout='prev, pager, next, jumper' :total='totalCount' @current-change='getProductList'>
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisable">
      <el-form>
        <table class="form-editor">
          <tr>
            <th><span class="required_column">*</span>产品名称</th>
            <td>
              <el-input placeholder="请输入产品名称" v-model="addProductParam.productName"></el-input>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>产品类别</th>
            <td>
              <el-select v-model="addProductParam.productTypeId" placeholder="请选择产品类别">
                <el-option v-for="item in productType" :key="item.itemId" :label="item.itemName" :value="item.itemId">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>所属单位</th>
            <td>
              <el-select v-model="addProductParam.productComid" placeholder="请选择所属单位">
                <el-option v-for="item in orgOptions" :key="item.orgId" :label="item.orgName" :value="item.orgId">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <th>产品推荐</th>
            <td>
              <el-radio-group v-model="addProductParam.productRecommend">
                <el-radio :label=1>
                  推荐
                </el-radio>
                <el-radio :label=0>
                  不推荐
                </el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>产品图片</th>
            <td>
              <el-upload class="avatar-uploader" action="/file/upload" :show-file-list="false"
                :on-success="uploadSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>详细介绍</th>
            <td>
              <ueditor :config="editorConfig" v-model="addProductParam.productText"></ueditor>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="addProducts">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看产品信息" :visible.sync="viewProductDialog">
      <el-form>
        <table class="form-editor">
          <tr>
            <th>产品名称</th>
            <td>
              {{addProductParam.productName}}
            </td>
          </tr>
          <tr>
            <th>所属单位</th>
            <td>
              {{addProductParam.companyName}}
            </td>
          </tr>
          <tr>
            <th>产品推荐</th>
            <td>
              <el-radio-group v-model="addProductParam.productRecommend" disabled>
                <el-radio :label=1>
                  推荐
                </el-radio>
                <el-radio :label=0>
                  不推荐
                </el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th>产品图片</th>
            <td>
              <el-upload class="avatar-uploader" action="/file/upload" :show-file-list="false"
                :on-success="uploadSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
          <tr>
            <th>详细介绍</th>
            <td>
              <p v-html="addProductParam.productText"></p>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="viewProductDialog=false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import * as productApi from '@/api/product';
import * as commonApi from '@/api/common';
export default {
  data() {
    return {
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      productType: [],
      imageUrl: '',
      dialogTitle: '',
      toggle: true,
      totalCount: 0,
      addProductParam: {
        productRecommend: 0
      },
      porductList: [],
      orgOptions: [],
      searchModel: {
        pageNo: 1,
        pageSize: 10
      },
      viewProductDialog: false,
      dialogVisable: false,
      picdialogVisible: false,
      options: [
        {
          label: '全部',
          value: '全部'
        },
        {
          label: '企业新闻',
          value: '企业新闻'
        },
        {
          label: '博士讲堂',
          value: '博士讲堂'
        },
        {
          label: '政策解读',
          value: '政策解读'
        },
        {
          label: '专业文献',
          value: '专业文献'
        }
      ],
      optionsTest: [
        {
          label: '全部',
          value: '全部'
        }
      ]
    };
  },
  methods: {
    getProductType() {
      productApi.getProductType().then(res => {
        this.productType = res.data;
      });
    },
    checkInfo(info) {
      if (!info.productName) {
        this.$notify({
          title: '警告',
          message: '请输入产品名称',
          type: 'warning'
        });
        return false;
      } else if (info.productName.length > 30) {
        this.$notify({
          title: '警告',
          message: '产品名称字数不能超过30',
          type: 'warning'
        });
        return false;
      } else if (!info.productImg) {
        this.$notify({
          title: '警告',
          message: '请选择产品图片',
          type: 'warning'
        });
        return false;
      } else if (!info.productText) {
        this.$notify({
          title: '警告',
          message: '请输入产品介绍',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    switchChange(row, state) {
      let confirmInfo = '';
      switch (state) {
        case 'productRecommend':
          confirmInfo = '是否更改当前产品推荐状态？';
          break;
        case 'productState':
          confirmInfo = '是否更改当前产品审核状态？';
          break;
        default:
          break;
      }
      this.$confirm(confirmInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (state === 'productRecommend') {
            productApi
              .recommendProduct({
                productId: row.productId,
                recommend: row.productRecommend
              })
              .then(res => {
                this.getProductList();
              });
          } else {
            productApi
              .auditProduct({
                productId: row.productId,
                state: row.productState
              })
              .then(res => {
                this.getProductList();
              });
          }
        })
        .catch(() => {
          if (state === 'productRecommend') {
            if (row.productRecommend === 1) {
              row.productRecommend = 0;
            } else {
              row.productRecommend = 1;
            }
          } else {
            if (row.productState === 1) {
              row.productState = 0;
            } else {
              row.productState = 1;
            }
          }
        });
    },
    addProducts() {
      if (this.checkInfo(this.addProductParam)) {
        if (this.addProductParam.productId) {
          productApi.updateProduct(this.addProductParam).then(res => {
            this.dialogVisable = false;
            this.addProductParam = {
              recommend: 0
            };
            this.imageUrl = '';
            this.getProductList();
          });
        } else {
          productApi.addProduct(this.addProductParam).then(res => {
            this.dialogVisable = false;
            this.addProductParam = {
              recommend: 0
            };
            this.imageUrl = '';
            this.getProductList();
          });
        }
      }
    },
    viewProductDetail(id) {
      productApi.getProductDetail({ productId: id }).then(res => {
        this.addProductParam = res.data;
        this.imageUrl = res.data.productImg;
        this.viewProductDialog = true;
      });
    },
    getProductDetail(id) {
      this.dialogTitle = '编辑产品信息';
      productApi.getProductDetail({ productId: id }).then(res => {
        this.addProductParam = res.data;
        this.imageUrl = res.data.productImg;
        this.dialogVisable = true;
      });
    },
    deleteProduct(id) {
      this.$confirm('是否删除该产品相关信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          productApi.deleteProduct({ productId: id }).then(res => {
            this.getProductList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    getOrglist() {
      commonApi.getOrglist().then(res => {
        this.orgOptions = res;
      });
    },
    uploadSuccess(res, file, fileList) {
      this.addProductParam.productImg = res.url;
      this.imageUrl = res.url;
    },
    getProductList() {
      productApi.getProductList(this.searchModel).then(res => {
        this.porductList = res.data.list;
        this.totalCount = res.data.totalCount;
      });
    }
  },
  created() {
    this.getProductList();
    this.getOrglist();
    this.getProductType();
  }
};
</script>
<style lang="stylus" scoped>
.page-panel-search-form {
  .el-form-item__content {
    .el-input.el-input--prefix.el-input--suffix {
      width 145px
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/productManagement/index.vue